export default class AddJobPlacementsToInvoiceRequest {
  jobPlacementIds: string[] = [];
}
